import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Content, Icon, Message } from 'rsuite';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { LIST_CONFIG } from '../../../constants/permissions';
import { MANAGE_GUEST } from '../../../constants/custom-list/Types';
import { MODULE as GUEST_MODULE } from '../../../constants/permissions/guest';
import { fullAccess, viewAccess } from '../../../helpers/permission';
import pagePathToUrl from '../../../helpers/pagePathToUrl';
import { fetchClients as fetchGuests } from '../../../redux/sagas/client/routines';
import PageHeader from '../../../components/PageHeader';
import PageLayout from '../../../components/guest/PageLayout';
import AccessDenied from '../../../components/AccessDenied';
import AccessControl from '../../../components/AccessControl';
import GuestSearch from '../../../containers/GuestSearch';
import redirectTo from '../../../helpers/redirectTo';
import history from '../../history';
import { guestsViewPath } from '../../Paths';

const StyledMessage = styled(Message)`
  > .rs-message-container {
    padding: 12px;
  }
`;

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(
    () => {
      dispatch(fetchGuests({ page: 1 }));
    },
    [location]
  );

  const handleSelectGuest = ({ id }) => {
    history.push(pagePathToUrl(guestsViewPath, { id, section: 'primary' }));
  };

  const handleListConfig = () => {
    redirectTo(`/settings/list-config/?type=${MANAGE_GUEST}`);
  };

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(GUEST_MODULE)}
        fallback={<AccessDenied />}
      >
        <StyledMessage
          type="info"
          description={
            <p>
              You are using the new Guest Management experience.
              <Button
                appearance="link"
                onClick={() => redirectTo('/manage/guest')}
              >
                Switch back to the previous version.
              </Button>
            </p>
          }
          showIcon
        />
        <PageHeader title="Guests" style={{ position: 'relative' }}>
          <AccessControl allowOnlyFor={fullAccess(LIST_CONFIG)}>
            <Button
              appearance="primary"
              onClick={handleListConfig}
              style={{ position: 'absolute', top: 20, right: 20 }}
            >
              <Icon icon="gear" /> List Config
            </Button>
          </AccessControl>
        </PageHeader>
        <Content style={{ marginTop: 0 }}>
          <GuestSearch
            hideCreate
            type={MANAGE_GUEST}
            showBarcodeSearch={false}
            onSelectGuest={handleSelectGuest}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
